import {
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { WindowRefService } from "src/app/services/window-ref.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { environment } from "src/environments/environment";
import { v4 as uuidv4 } from "uuid";
import { Checkout } from "capacitor-razorpay";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { Capacitor } from "@capacitor/core";
@Component({
  selector: "sm-employee-plans-list",
  templateUrl: "./employee-plans-list.component.html",
  styleUrls: ["./employee-plans-list.component.scss"],
})
export class EmployeePlansListComponent implements OnInit, OnDestroy {
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
          )!
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);

  _apisub: Subscription;
  plansList: any = [];
  loader: boolean = false;
  noOfMonths: number = 1;
  noOfEmployees: number = 1;
  constructor(
    private route: ActivatedRoute,
    private _navService: NavigationService,
    private loaderService: LoaderServiceService,
    private _apiService: ApiService,
    private winRef: WindowRefService,
    private _router: Router,
    private ngzone: NgZone,
    private dialog: MatDialog
  ) {
    this._navService.hideSidebarAndNav = false;

    this._apisub = this._apiService.apiResult.subscribe((resData) => {
      if (resData.responseType === SM_CONSTANTS.RESULT_API_GET_PLANS_LIST) {
        this.plansList = [];
        if (resData.result) {
          resData.result.forEach((element: any) => {
            if (element.eligibilityType == 2) {
              element.selected = false;
              // if(element.perUnitCost > 0 && element.validity_count == 365){
              //   element.selected = true
              //   this.selectedPlan = element
              // }else{
              // }
              this.plansList.push(element);
            }
          });
        }
        console.log(this.plansList);

        this.loaderService.showLoader = false;
        this.loader = false;
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_CREATE_SUBSCRIPTION_ORDER
      ) {
        if (resData.result) {
          this.loaderService.showLoader = false;
          this.payWithRazor(resData.result.id, resData.result.amount * 100);
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_VALIDATE_PAYMENT_SIGNATURE
      ) {
        if (resData.result) {
          if (resData.result.signatureIsValid == "true") {
            console.log(this.selectedPlan);

            let data = {
              transactionInfo: {
                planHash: this.selectedPlan.hash_id,
                noOfUsers: this.noOfEmployees,
                noOfEntity: 0,
                fromDate: this.formatDateString(new Date()),
                toDate: this.addDaysToDate(
                  new Date(),
                  +this.selectedPlan.validity_count * this.noOfMonths
                ),
                validity: +this.selectedPlan.validity_count * this.noOfMonths,
                totalCost:
                  this.selectedPlan.perUnitCost *
                  this.noOfMonths *
                  this.noOfEmployees,
                unitCost: this.selectedPlan.perUnitCost,
                paymentType: 1,
                paymentRef: this.paymentResponse.razorpay_payment_id,
                currency: this.selectedPlan.currency,
                currencySymbol: this.selectedPlan.currency_symbol,
              },
            };

            this._apiService.updatePaymentRecord(data);
          }
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_PAYMENT_RECORD
      ) {
        if (resData.result) {
          this._apiService.getSubcriptionHistoryById(
            localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
            "1",
            this.countryInfo.countryCode
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_SUBSCRIPTION_HISTORY_BY_ID
      ) {
        if (resData.result) {
          // this.loaderService.showLoader = false
          this.ngzone.run(() => {
            this.loaderService.showLoader = false;
            sessionStorage.setItem(
              SM_CONSTANTS.SELECTED_EMPLOYEE_PURCHASED_PLAN,
              JSON.stringify(resData.result[0])
            );
            console.log(
              sessionStorage.getItem(
                SM_CONSTANTS.CURRENT_ROUTE_FOR_NEW_EMPLOYEE
              )
            );

            if (
              sessionStorage.getItem(
                SM_CONSTANTS.CURRENT_ROUTE_FOR_NEW_EMPLOYEE
              ) == "1"
            ) {
              this._router.navigate(["../employee"], {
                relativeTo: this.route,
              });
            } else if (
              sessionStorage.getItem(
                SM_CONSTANTS.CURRENT_ROUTE_FOR_NEW_EMPLOYEE
              ) == "2"
            ) {
              this._router.navigate(["../employee"], {
                relativeTo: this.route,
                queryParamsHandling: "preserve",
              });
            }
          });

          // this._router.navigate(['business-create'])
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_USER_SUBSCRIPTION_INFO
      ) {
        if (resData.result) {
           this.ngzone.run(() => {
            this.loaderService.showLoader = false;
            this._router.navigate(["../"], {
              queryParamsHandling: "preserve",
              relativeTo: this.route,
            });
          });
        }
      }
    });
  }
  entityHashId: string = "";
  employeehash: string = "";
  ngOnInit(): void {
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
      this.employeehash = data.employeeHash;
    });
    this.loader = true;
    this.loaderService.showLoader = true;
    this._apiService.getPlansList();
    sessionStorage.setItem("eplanslistroute", "buy");
  }
  @ViewChild("bottomElement") bottomElement!: ElementRef;
  selectedPlan: any = null;
  selectPlan(index: any) {
    this.showPaypalSheet = false;
    this.noOfMonths = 1;
    this.noOfEmployees = 1;
    this.plansList.forEach((element: any) => {
      element.selected = false;
    });

    this.plansList[index].selected = true;
    this.selectedPlan = this.plansList[index];
    setTimeout(() => {
      this.bottomElement.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 1);
    if (
      this.selectedPlan.perUnitCost > 0 &&
      this.countryInfo.currency != "INR"
    ) {
      this.onContinue();
    }
  }
 onContinue() {
    if (this.selectedPlan.perUnitCost > 0) {
      if (this.countryInfo.currency == "INR") {
        this.loaderService.showLoader = true;
        let data = {
          amount: (
            this.selectedPlan.perUnitCost *
            100 *
            this.noOfMonths *
            this.noOfEmployees
          ).toString(),
          currency: this.selectedPlan.currency,
          receipt: this.generateReceiptNumber(),
          currency_symbol: this.selectedPlan.currency_symbol,
          plan_hash: this.selectedPlan.hash_id,
          account_hash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          no_of_entity: 0,
          no_of_users: this.noOfEmployees,
          total_cost: this.selectedPlan.perUnitCost *
                  this.noOfMonths *
                  this.noOfEmployees,
          unit_cost: this.selectedPlan.perUnitCost,
          created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        };

        console.log(data);

        this._apiService.createSubscriptionOrder(data);
      } else {
        //INTERNATIONAL PAYMENTS
        let data = {
          // "entity_hash": "dc9c361261775779d463ccd9889602b66b135f48", //not possible
          // "entityName": "Glamour and Spa", // not possible
          accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          currency: this.selectedPlan.currency,
          currency_symbol: this.selectedPlan.currency_symbol,
          transactionInfo: {
            planHash: this.selectedPlan.hash_id,
            noOfUsers: this.noOfEmployees,
            noOfEntity: 0,
            fromDate: this.formatDateString(new Date()),
            toDate: this.addDaysToDate(
              new Date(),
              +this.selectedPlan.validity_count * this.noOfMonths
            ),
            validity: +this.selectedPlan.validity_count * this.noOfMonths,
            totalCost:
              this.selectedPlan.perUnitCost *
              this.noOfMonths *
              this.noOfEmployees,
            unitCost: this.selectedPlan.perUnitCost,
            paymentType: 1,
            currency: this.selectedPlan.currency,
            currencySymbol: this.selectedPlan.currency_symbol,
            accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          },
          subscription_plan_hash: this.selectedPlan.hash_id,
          amount:
            this.selectedPlan.perUnitCost *
            this.noOfMonths *
            this.noOfEmployees,
        };
        this.subscriptionDataToSend = data;
        this.openPaypalSheet();
      }
    } else {
      this.loaderService.showLoader = true;
      this.paymentResponse = {
        signature: "test",
      };
      let data = {
        transactionInfo: {
          planHash: this.selectedPlan.hash_id,
          noOfUsers: this.noOfEmployees,
          noOfEntity: 0,
          fromDate: this.formatDateString(new Date()),
          toDate: this.addDaysToDate(
            new Date(),
            +this.selectedPlan.validity.split(" ")[0]
          ),
          validity: +this.selectedPlan.validity.split(" ")[0],
          totalCost: this.selectedPlan.perUnitCost,
          unitCost: this.selectedPlan.perUnitCost,
          paymentType: 1,
          paymentRef: "",
          currency: this.selectedPlan.currency,
          currencySymbol: this.selectedPlan.currency_symbol,
        },
      };

      this._apiService.updatePaymentRecord(data);
    }
  }
  changeNoOfEmployees(value: any) {
    if (value == 0) {
      this.noOfEmployees -= 1;
    } else if (value == 1) {
      this.noOfEmployees += 1;
    }
     let data = {
      // "entity_hash": "dc9c361261775779d463ccd9889602b66b135f48", //not possible
      // "entityName": "Glamour and Spa", // not possible
      accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      currency: this.selectedPlan.currency,
      currency_symbol: this.selectedPlan.currency_symbol,
      transactionInfo: {
        planHash: this.selectedPlan.hash_id,
        noOfUsers: this.noOfEmployees,
        noOfEntity: 0,
        fromDate: this.formatDateString(new Date()),
        toDate: this.addDaysToDate(
          new Date(),
          +this.selectedPlan.validity_count * this.noOfMonths
        ),
        validity: +this.selectedPlan.validity_count * this.noOfMonths,
        totalCost:
          this.selectedPlan.perUnitCost * this.noOfMonths * this.noOfEmployees,
        unitCost: this.selectedPlan.perUnitCost,
        paymentType: 1,
        currency: this.selectedPlan.currency,
        currencySymbol: this.selectedPlan.currency_symbol,
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      },
      subscription_plan_hash: this.selectedPlan.hash_id,
      amount:
        this.selectedPlan.perUnitCost * this.noOfMonths * this.noOfEmployees,
    };
    this.subscriptionDataToSend = data;
  }
  generateReceiptNumber(): string {
    return uuidv4();
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  addDaysToDate(currentDate: Date, daysToAdd: number): string {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + daysToAdd);

    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, "0");
    const day = String(newDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  paymentResponse: any = null;

  async payWithRazor(val: any, amount: any) {
    if (Capacitor.isNativePlatform()){
      const options = {
        key: environment.razorpayKey,
        amount: amount,
        order_id: val, //Order ID generated in Step 1
        currency: this.selectedPlan.currency,
        theme: {
          color: "#0c238a",
        },
      };
      try {
        let data = await Checkout.open(options);
  
        this.paymentResponse = data.response;
        this.ngzone.run(() => {
          this.loaderService.showLoader = true;
          this._apiService.validatePaymentSignature(data.response);
        });
  
        // this.dialog.open(AlertForMobileLogComponent,{
        //   data:{
        //     data: JSON.stringify(data)
        //   }
        // })
      } catch (error: any) {
        this.ngzone.run(() => {
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            data: {
              title: "Alert",
              message:
                "The payment process interrupted and couldn't be completed. Try again if not done intentionally.",
              okbtn: "Ok",
              cancelbtn: "Ok",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
          console.log("Transaction cancelled.");
        });
      }

    }else{
       console.log(val, amount);

    const options: any = {
      //OLD KEY
      // key: 'rzp_test_Z3ZWXkX2GZF6Hd',

      //NEW KEY
      key: environment.razorpayKey,

      amount: amount, // amount should be in paise format to display Rs 1255 without decimal point

      currency: this.selectedPlan.currency,

      order_id: val, // order_id created by you in backend

      modal: {
        // We should prevent closing of the form when esc key is pressed.

        escape: false,
      },

      theme: {
        color: "#0c238a",
      },
    };

    options.handler = (response: any, error: any) => {
      options.response = response;

      this.paymentResponse = response;
      this.ngzone.run(() => {
        this.loaderService.showLoader = true;
        this._apiService.validatePaymentSignature(response);
      });

      // call your backend api to verify payment signature & capture transaction
    };

    options.modal.ondismiss = () => {
      // handle the case when user closes the form while transaction is in progress
      this.ngzone.run(() => {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "The payment process interrupted and couldn't be completed. Try again if not done intentionally.",
            okbtn: "Ok",
            cancelbtn: "Ok",
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
        console.log("Transaction cancelled.");
      });
    };

    const rzp = new this.winRef.nativeWindow.Razorpay(options);

    rzp.open();
    }
  }

  ngOnDestroy(): void {
    this._apisub.unsubscribe();
  }


  showPaypalSheet = false;
  openPaypalSheet() {
    this.showPaypalSheet = true;
  }

  subscriptionDataToSend: any;
  closePaypalSheet(eventData: any) {
    console.log(eventData);

    if (eventData) {
      this.showPaypalSheet = false;
      console.log("Closed after success:", eventData);
      this.loaderService.showLoader = true;
      this._apiService.getSubcriptionHistoryById(
        localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        "1",
        this.countryInfo.countryCode
      );
    } else {
      console.log("Closed manually");
    }
  }

  changeMonths(event: any) {
    console.log(event);
    //INTERNATIONAL PAYMENTS
    let data = {
      // "entity_hash": "dc9c361261775779d463ccd9889602b66b135f48", //not possible
      // "entityName": "Glamour and Spa", // not possible
      accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      currency: this.selectedPlan.currency,
      currency_symbol: this.selectedPlan.currency_symbol,
      transactionInfo: {
        planHash: this.selectedPlan.hash_id,
        noOfUsers: this.noOfEmployees,
        noOfEntity: 0,
        fromDate: this.formatDateString(new Date()),
        toDate: this.addDaysToDate(
          new Date(),
          +this.selectedPlan.validity_count * this.noOfMonths
        ),
        validity: +this.selectedPlan.validity_count * this.noOfMonths,
        totalCost:
          this.selectedPlan.perUnitCost * this.noOfMonths * this.noOfEmployees,
        unitCost: this.selectedPlan.perUnitCost,
        paymentType: 1,
        currency: this.selectedPlan.currency,
        currencySymbol: this.selectedPlan.currency_symbol,
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      },
      subscription_plan_hash: this.selectedPlan.hash_id,
      amount:
        this.selectedPlan.perUnitCost * this.noOfMonths * this.noOfEmployees,
    };
    this.subscriptionDataToSend = data;
  }
}
